module.exports = __webpack_public_path__ + "i4t2.png?1274fd184fdb5eba18b07ea71727478a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/i4t2.png
// module id = 201
// module chunks = 0